export default "__VITE_ASSET__l_QTKf8k__"